import { Navigate, useOutletContext } from 'react-router-dom';
import { NAV } from '@/lib/nav';
import type { Program } from '@/lib/types';

/** Tabs not built yet: show the shape of the tool and when the tab lands. */
export function Placeholder({ path }: { path: string }) {
  const program = useOutletContext<Program>();
  const item = NAV.find((n) => n.path === path);
  if (!item) return <Navigate to={`/p/${program.id}/tracker`} replace />;
  if (item.requires && !program.capabilities.includes(item.requires))
    return <Navigate to={`/p/${program.id}/tracker`} replace />;
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-xl border border-border bg-surface text-muted shadow-xs">
          <item.icon className="size-5" />
        </div>
        <h1 className="text-lg font-semibold">{item.label}</h1>
        <p className="mt-1.5 text-sm text-muted">{item.description}</p>
        <p className="mt-4 inline-block rounded-full border border-border bg-surface px-3 py-1 text-xs text-muted">
          Arrives in Sprint {item.sprint}
        </p>
      </div>
    </div>
  );
}
